import { MenuItem, TextField } from '@material-ui/core';
import React, { Fragment, useEffect, useState, useReducer } from 'react';
import { Row, Col, Table, Button } from 'reactstrap';
import InfoPatient from '../InfoPatient';
import { INITIAL_STATE, vitalSignsReducer } from './vitalSignsReducer';
import ModalUI from '../../../../../shared/components/Modal';

const no_op = () => { }
const VitalSignsHC = ({ data, openVitalSigns = false, setOpenVitalSigns = no_op, callbackupdateStatusVitalSigns = no_op }) => {
    const [disabledFields, setDisabledFields] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });
    const [errors, setErrors] = useState({});

    const user = JSON.parse(sessionStorage.getItem('usuario'));
    const [state, dispatch] = useReducer(vitalSignsReducer, INITIAL_STATE);

    useEffect(() => {
        const { peso, talla } = data;
        console.log({ peso, talla })
        if (!!peso) dispatch({ type: 'CALCULATE_IBM_MC', payload: { name: 'weight', value: peso } });
        if (!!talla) dispatch({ type: 'CALCULATE_IBM_MC', payload: { name: 'height', value: talla } });

        const loadPhysicalExam = async () => {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'fisico/consultar-admision', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({ id_admision: data.id_admision })
            })
                .then(response => {
                    if (response.status != 500 && response.status != 403) {
                        return response.json();
                    }
                    else {
                        throw new Error("Ha ocurrido un error en el Servidor");
                    }
                })
                .then(data => {
                    if (data.existe) {
                        console.log({ data: data.contenido[0] })
                        dispatch({ type: 'CHARGE_FIELDS', payload: data.contenido[0] })
                        setDisabledFields(true);
                    }
                }).catch((error) => {
                    console.error('Error:', error);
                });
        }

        loadPhysicalExam()
    }, [])

    const saveVitalSigns = async () => {
        if (!validateFields()) {
            let dataSend = {
                id_historia: data.id_historia,
                id_admision: data.id_admision,
                peso: state.weight,
                talla: state.height,
                masa_corporal: state.imc,
                superficie_corporal: state.bodySurface,
                frecuencia_cardiaca: state.heartRate,
                frecuencia_respiratoria: state.breathingFrequency,
                presion_arterial: state.bloodPressureMM,
                presion_arterial2: state.bloodPressureHg,
                id_usuario: user.id_usuario
            }
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'fisico/guardar-signos-vitales', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    if (response.status != 500 && response.status != 403) {
                        return response.json();
                    }
                    else {
                        throw new Error("Ha ocurrido un error en el Servidor");
                    }
                })
                .then(data => {
                    if (!!data.data) {
                        dispatch({ type: 'CLEAR_FORM' })
                        setOpenAlert(true);
                        setModalAlert({
                            message: "Guardado con exito",
                            color: 'success',
                            title: "Exitoso!"
                        });
                    }
                }).catch((error) => {
                    console.error('Error:', error);
                });
        }
    }

    const validateFields = () => {
        const validate_errors = {};
        var error = false;
        if (state.weight == "") {
            validate_errors.weight = "Ingrese el peso";
            error = true;
        }

        if (state.height == '') {
            validate_errors.height = "Ingrese la altura";
            error = true;
        }

        if (state.bloodPressureMM == '') {
            validate_errors.bloodPressureMM = "Ingrese la presión arterial";
            error = true;
        }

        if (state.bloodPressureHg == '') {
            validate_errors.bloodPressureHg = "Ingrese la presión arterial";
            error = true;
        }

        setErrors(validate_errors);
        return error;
    }

    const onOkModal = () => {
        switch (modalAlert.color) {
            case "success":
                setOpenAlert(!openAlert);
                setOpenVitalSigns(false);
                callbackupdateStatusVitalSigns(data.id_admision, true)
                break;
            case "warning":
                break;
            case "danger":
                break;
        }
    }

    const onHandlerFormInputs = (event) => {
        dispatch({ type: 'CHANGE_INPUT', payload: { name: event.target.name, value: event.target.value } })
    }

    const onHandlerHeightAndHeight = (event) => {
        dispatch({ type: 'CALCULATE_IBM_MC', payload: { name: event.target.name, value: event.target.value } })
    }

    return (
        <Fragment>
            <Row>
                <div className="title-general">
                    <h3 style={{ margin: '0.25em 0em' }}>Antropometría | Examen Físico</h3>
                </div>
            </Row>
            <Row>
                <InfoPatient dataPatient={data} />
            </Row>
            <Row className="row-form-custom">
                <Col md={3}>
                    <TextField
                        className="medical-material-form__field"
                        name='weight'
                        value={state.weight || ''}
                        disabled={disabledFields}
                        id="weight-required"
                        label="Peso (kg)"
                        type="number"
                        error={errors.hasOwnProperty("weight") ? errors.weight !== "" : false}
                        helperText={errors.weight}
                        onChange={(e) => {
                            onHandlerHeightAndHeight(e);
                        }}
                    />
                </Col>
                <Col md={3}>
                    <TextField
                        className="medical-material-form__field"
                        name='height'
                        value={state.height || ''}
                        disabled={disabledFields}
                        id="height-required"
                        label="Talla (cm)"
                        type="number"
                        error={errors.hasOwnProperty("height") ? errors.height !== "" : false}
                        helperText={errors.height}
                        onChange={(e) => {
                            onHandlerHeightAndHeight(e);
                        }}
                    />
                </Col>
                <Col md={3}>
                    <TextField
                        className="medical-material-form__field"
                        name='imc'
                        value={state.imc || ''}
                        id="first-last-name-standard-required"
                        label="Indice de masa corporal"
                        type="number"
                        disabled={true}
                        onChange={(e) => {
                        }}
                    />
                </Col>
                <Col md={3}>
                    <TextField
                        className="medical-material-form__field"
                        name='bodySurface'
                        value={state.bodySurface || ''}
                        id="first-last-name-standard-required"
                        label="Superficie corporal (mc)"
                        type="number"
                        disabled={true}
                        onChange={(e) => {
                        }}
                    />
                </Col>
            </Row>
            <Row className="row-form-custom">
                <Col md={3}>
                    <TextField
                        className="medical-material-form__field"
                        name='heartRate'
                        value={state.heartRate || ''}
                        disabled={disabledFields}
                        id="heart-rate"
                        label="Frecuencia Cardiaca (lmp)"
                        type="number"
                        onChange={(e) => {
                            onHandlerFormInputs(e);
                        }}
                    />
                </Col>
                <Col md={3}>
                    <TextField
                        className="medical-material-form__field"
                        name='breathingFrequency'
                        value={state.breathingFrequency || ''}
                        disabled={disabledFields}
                        id="breathing-frequency"
                        label="Frecuencia respiratoria (resp/min)"
                        type="number"
                        onChange={(e) => {
                            onHandlerFormInputs(e);
                        }}
                    />
                </Col>
                <Col md={3}>
                    <TextField
                        required
                        className="medical-material-form__field"
                        name='bloodPressureMM'
                        value={state.bloodPressureMM || ''}
                        disabled={disabledFields}
                        id="blood-pressure"
                        label="Presión Arterial mm"
                        type="number"
                        error={errors.hasOwnProperty("bloodPressureMM") ? errors.bloodPressureMM !== "" : false}
                        helperText={errors.bloodPressureMM}
                        onChange={(e) => {
                            onHandlerFormInputs(e);
                        }}
                    />
                </Col>
                <Col md={3}>
                    <TextField
                        required
                        className="medical-material-form__field"
                        name='bloodPressureHg'
                        disabled={disabledFields}
                        value={state.bloodPressureHg || ''}
                        id="blood-pressure-2"
                        label="Presión Arterial Hg"
                        type="number"
                        error={errors.hasOwnProperty("bloodPressureHg") ? errors.bloodPressureHg !== "" : false}
                        helperText={errors.bloodPressureHg}
                        onChange={(e) => {
                            onHandlerFormInputs(e);
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className='flex-end-elem'>
                        <div className='flex-end-elem-elemt'>
                            <Button
                                variant="contained"
                                color="primary"
                                size='sm'
                                onClick={() => {
                                    setOpenVitalSigns(false);
                                }}>
                                Cerrar
                            </Button>
                        </div>
                        <div className='flex-end-elem-elemt'>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={disabledFields}
                                size='sm'
                                onClick={() => {
                                    saveVitalSigns();
                                }}>
                                Guardar
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>
            {openAlert ?
                <ModalUI
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={openAlert}
                    toggle={() => { setOpenAlert(!openAlert) }}
                    onOk={() => onOkModal()}
                /> : null}
        </Fragment>
    )
}
export default VitalSignsHC